import Head from 'next/head';
import { absoluteUrl } from 'common/Seo';
import { safeJsonLd } from 'common/utils/safeJsonLd';

export type BreadcrumbItem = {
  name: string;
  url: string;
};

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(({ name, url }, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name,
      item: absoluteUrl(url),
    })),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: safeJsonLd(schema) }}
      />
    </Head>
  );
}
